import * as React from 'react';
import { useState, useEffect } from 'react'
import FormInput from '../../../common/form/Input';
import {
    AdvancedConfiguration,
    BrivoPropertyConfiguration,
    MasterLockConfiguration,
    MasterLockPropertyConfiguration,
    fetchKeyCafeKeyGroups,
    fetchKeyCafeKeys,
    fetchKeyCafeLocations,
    keyCafeKeyGroups,
    updateAdvancedConfiguration
} from '../../../../api/PropertyIntegration';
import Form from '../../../common/form/Form';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import { ReportFrequency } from '../../../../utilities/Enums';
import FormSelectLabeled from '../../../common/form/SelectLabeled';
import { userIsSystemAdmin } from '../../../../utilities/identity';
import OnCellConfigurationSection from './integrationControls/OnCellConfigurationSection';
import DoorKingConfigurationSection from './integrationControls/DoorKingConfigurationSection';
import BmxConfigurationSection from './integrationControls/BmxConfigurationSection';
import RemoteLockConfigurationSection from './integrationControls/RemoteLockConfigurationSection';
import EntrataConfigurationSection from './integrationControls/EntrataConfigurationSection';
import StratisConfigurationSection from './integrationControls/StratisConfigurationSection';
import Lead2LeaseConfigurationSection from './integrationControls/Lead2LeaseConfigurationSection';
import IntelligentLeadConfigurationSection from './integrationControls/IntelligentLeadConfigurationSection';
import AnyoneHomeConfigurationSection from './integrationControls/AnyoneHomeConfigurationSection';
import ManualAccessConfigurationSection from './integrationControls/ManualAccessConfigurationSection';
import { IgloohomeLocksModal } from './integrationControls/IgloohomeLocksModal';
import KnockConfigurationSection from './integrationControls/KnockConfigurationSection';
//import LatchConfigurationSection from './integrationControls/LatchConfigurationSection';
import { Company, getCompany } from '../../../../api/Company';
import CompanyMigrationSection from './CompanyMigrationSection';
import { Property } from '../../../../api/Property';
import PropertyCancellationDateSection from './PropertyCancellationDateSection';
import YardiConfigurationSection from './integrationControls/YardiConfigurationSection';
import OneSiteConfigurationSection from './integrationControls/OneSiteConfigurationSection';
import { IdVerificationTypes } from '../../../../api/IdVerification';
// import { MasterLockModal } from './integrationControls/MasterLockModal';
import FunnelConfigurationSection from './integrationControls/FunnelConfigurationSection';
import HylyConfigurationSection from './integrationControls/HylyConfigurationSection';
import SmartRentConfigurationSection from './integrationControls/SmartRentConfiguration';
import LatchAdvConfigurationSection from './integrationControls/LatchAdvConfigurationSection';
import GeoKeyConfigurationSection from './integrationControls/GeoKeyConfigurationSection';
import RentCafeConfigurationSection from './integrationControls/RentCafeConfigurationSection';
import BrivoConfigurationSection from './integrationControls/BrivoConfigurationSection';
import AmazonKeyConfigurationSection from './integrationControls/AmazonKeyConfigurationSection';
import MasterLockConfigurationSection from './integrationControls/MasterLockConfigurationSection';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../utilities/identity';
import KeyCafeConfigurationSection from './integrationControls/KeyCafeConfigurationSection';

interface Props {
    advancedConfiguration: AdvancedConfiguration;
    wasFormValidated: boolean;
    onFormValidated: () => void;
    onChange: (name: string, newValue: any) => void;
    onMultipleChange: (changes: { [key: string]: any }) => void;
    reload: () => Promise<void>;
    errorMessage?: string;
    setError: (error?: string) => void;
    setIsLoading: (isLoading: boolean) => void;
    propertyId: number;
    companiesList: Company[] | undefined;
    property?: Property;
    companyId?: number;
    previousBrivoConfiguration?: BrivoPropertyConfiguration;
}

const AdvancedTab = (props: Props) => {
    
const isUser =
userIsCompanyManageUser() ||
userIsPropertyManageUser() ||
userIsSystemManageUser();
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    let hasFullAccess = userIsSystemAdmin();
    let advancedConfiguration = props.advancedConfiguration;
    const [latchConfigOpen, setLatchConfigOpen] = useState(false);
    const [keyLocations, setKeyLocations] = useState();
    const [keyCafeKeys, setKeyCafeKeys] = useState([]);
    const [keyGroups, setKeyGroups] = useState<keyCafeKeyGroups[]>();
    const [keyCafeGroupIdChanged, setKeyCafeGroupIdChanged] = useState(false);

    useEffect(()=>{
        if(props.companyId){
            fetchCompanyDetails()
            fetchKeyGroups()
        }
    },[props.companyId])

    const callFetchKeyCafeKeys = async (keyGroupId: string) =>{
        let keyCafeKeysRes = await fetchKeyCafeKeys(keyGroupId)
        if (keyCafeKeysRes.success && keyCafeKeysRes.data) {
            const keyCafeKeysData = keyCafeKeysRes.data.map((item: any) => ({
                keyId: item.key.id,
                keyName: item.key.name,
                propertyId: props.propertyId
            }));
            setKeyCafeKeys(keyCafeKeysData)
        }
    }

    useEffect(()=>{
        if(props.advancedConfiguration.keyCafePropertyConfiguration && props.advancedConfiguration.keyCafePropertyConfiguration.keyCafeKeyGroupId !== "" && (keyCafeKeys.length === 0 || keyCafeGroupIdChanged)){
            callFetchKeyCafeKeys(props.advancedConfiguration.keyCafePropertyConfiguration.keyCafeKeyGroupId)
        }
        if(keyCafeGroupIdChanged){
            props.onChange('keyCafePropertyKeys',  [])
        }
        setKeyCafeGroupIdChanged(false)
        
    }, [props.advancedConfiguration.keyCafePropertyConfiguration])

    useEffect(() => {
        if ((props.advancedConfiguration.latchAdvPropertyConfiguration && props.advancedConfiguration.latchAdvPropertyConfiguration.buildingId) ||
            (advancedConfiguration.latchConfiguration && advancedConfiguration.latchConfiguration.latchKeys && advancedConfiguration.latchConfiguration.latchKeys.length > 0)) {
            setLatchConfigOpen(true);
        }
    }, [props.advancedConfiguration.latchAdvPropertyConfiguration]);

    const fetchCompanyDetails = async () => {
        if(props.companyId){
            try {
                let result = await getCompany(props.companyId)
                if (result.success && result.data) {
                 let keyLocationsRes = await fetchKeyCafeLocations(result.data.keyCafeGroupId === ""?"0":result.data.keyCafeGroupId)
                 if (keyLocationsRes.success && keyLocationsRes.data) {
                    const locationKeys = keyLocationsRes.data.map((item: any) => ({
                        id: item.location.id,
                        name: item.location.name
                    }));
                    setKeyLocations(locationKeys)
                 }

                }
              } catch (error) {
                console.error('Error fetching tour data:', error);
              }
        }
        
    }

    const fetchKeyGroups = async () =>{
        try {
            let result = await fetchKeyCafeKeyGroups()
            if (result.success && result.data) {
                setKeyGroups(result.data)
            }
          } catch (error) {
            console.error('Error fetching tour data:', error);
          }  
    }


    const handleSubmit = async () => {
       
        props.onFormValidated();
        props.setIsLoading(true);
        setIsFormSubmitted(true);  

        if (!latchConfigOpen) {
            props.onChange('latchAdvPropertyConfiguration', undefined);
            props.onChange('latchConfiguration', undefined);
            advancedConfiguration.latchAdvPropertyConfiguration = undefined;
            advancedConfiguration.latchConfiguration = undefined;
        }
        let result = await updateAdvancedConfiguration(props.propertyId, advancedConfiguration);
        props.setError(result.error);
        props.setIsLoading(false);
        props.reload();
    };

    return (
        <Form
            wasFormValidated={props.wasFormValidated}
            inBootstrapColumn={true}
            submitButtonText={'Save'} 
            onSubmit={handleSubmit}
            onFormValidated={props.onFormValidated}
            disabled={isUser}
        >

            <FormValidationDisplay errorMessage={props.errorMessage} />

            <h4>Integrations</h4>
            {advancedConfiguration.entrataConfiguration ||
                advancedConfiguration.yardiConfiguration ||
                advancedConfiguration.oneSiteConfiguration ? (
                <FormInput
                    labelProps={{
                        labelText: 'Default Source for Leads',
                        invalidText: 'Please choose a default source for Lead Forwarding'
                    }}
                    inputProps={{
                        name: 'defaultForwardedSource',
                        id: 'default-forwarded-source',
                        value: advancedConfiguration.defaultForwardedSource,
                        required: false,
                        disabled: isUser
                    }}
                    helpTextProps={{
                        helpText:
                            'If no source is identified, this will be sent as the lead source ' +
                            '("Property Website" is typical).'
                    }}
                    onChange={(_name, value) => props.onChange('defaultForwardedSource', value)}
                />
            ) : null}
            <EntrataConfigurationSection
                config={advancedConfiguration.entrataConfiguration}
                update={newConfig => props.onChange('entrataConfiguration', newConfig)}
            />
            <Lead2LeaseConfigurationSection
                config={advancedConfiguration.lead2LeaseConfiguration}
                update={newConfig => props.onChange('lead2LeaseConfiguration', newConfig)}
            />
            <YardiConfigurationSection
                config={advancedConfiguration.yardiConfiguration}
                update={newConfig => props.onChange('yardiConfiguration', newConfig)}
            />
           
            <RentCafeConfigurationSection
                config={advancedConfiguration.rentCafeConfiguration}
                update={newConfig => props.onChange('rentCafeConfiguration', newConfig)}
            />

            <OneSiteConfigurationSection
                config={advancedConfiguration.oneSiteConfiguration}
                update={newConfig => props.onChange('oneSiteConfiguration', newConfig)}
            />

            <KnockConfigurationSection
                config={advancedConfiguration.knockConfiguration}
                update={newConfig => props.onChange('knockConfiguration', newConfig)}
            />

            <FunnelConfigurationSection
                config={advancedConfiguration.funnelConfiguration}
                update={newConfig => props.onChange('funnelConfiguration', newConfig)}
            />

            <HylyConfigurationSection
                config={advancedConfiguration.hylyConfiguration}
                update={newConfig => props.onChange('hylyConfiguration', newConfig)}
            />

            <IntelligentLeadConfigurationSection
                config={advancedConfiguration.intelligentLeadConfiguration}
                update={newConfig => props.onChange('intelligentLeadConfiguration', newConfig)}
            />

            <AnyoneHomeConfigurationSection
                config={advancedConfiguration.anyoneHomeConfiguration}
                update={newConfig => props.onChange('anyoneHomeConfiguration', newConfig)}
            />

               <h4>Tour Access Integrations</h4>
            <ManualAccessConfigurationSection
                propertyId={props.propertyId}
                manualCodesEnabled={advancedConfiguration.manualCodesEnabled}
                setPageError={props.setError}
                updateManualCodesEnabled={enabled => props.onChange('manualCodesEnabled', enabled)}
                setPageLoading={props.setIsLoading}
            />
            {hasFullAccess && (
                <>
                    <RemoteLockConfigurationSection
                        propertyId={props.propertyId}
                        remoteLockGroupName={advancedConfiguration.remoteLockGroupName}
                        reload={props.reload}
                    />
                    <div className="row">
                        <div className="col">
                            <IgloohomeLocksModal
                                igloohomeConfiguration={
                                    advancedConfiguration.igloohomePropertyConfiguration
                                }
                                propertyId={props.propertyId}
                                reload={props.reload}
                                update={newConfig =>
                                    props.onChange('igloohomePropertyConfiguration', newConfig)
                                }
                                setIsLoading={props.setIsLoading}
                            />
                        </div>
                    </div>
                    {/* <div className="row">
                        <div className="col">
                            <MasterLockModal
                                masterLockConfiguration={
                                    props.advancedConfiguration.masterLockConfiguration
                                }
                                propertyId={props.propertyId}
                                reload={props.reload}
                                update={newConfig =>
                                    props.onChange('masterLockConfiguration', newConfig)
                                }
                                setIsLoading={props.setIsLoading}
                            />
                        </div>
                    </div> */}
                    {/* <LatchConfigurationSection
                        config={advancedConfiguration.latchConfiguration}
                        propertyId={props.propertyId}
                        setPageError={props.setError}
                        setPageLoading={props.setIsLoading}
                        update={newConfig => props.onChange('latchConfiguration', newConfig)}
                    /> */}
                    <StratisConfigurationSection
                        config={advancedConfiguration.stratisConfiguration}
                        update={newConfig => props.onChange('stratisConfiguration', newConfig)}
                    />

                    <SmartRentConfigurationSection
                        config={advancedConfiguration.smartRentConfiguration}
                        reload={props.reload}
                        id={props.propertyId}
                        update={newConfig => props.onChange('smartRentConfiguration', newConfig)}
                        setIsLoading={props.setIsLoading}
                    />

                    <DoorKingConfigurationSection
                        config={advancedConfiguration.doorKingConfiguration}
                        update={newConfig => props.onChange('doorKingConfiguration', newConfig)}
                    />

                    <BmxConfigurationSection
                        propertyId={props.propertyId}
                        config={advancedConfiguration.bMXConfiguration}
                        update={newConfig => props.onChange('bMXConfiguration', newConfig)}
                    />

                    <LatchAdvConfigurationSection
                        propertyId={props.propertyId}
                        config={advancedConfiguration.latchAdvPropertyConfiguration}
                        update={newConfig => props.onChange('latchAdvPropertyConfiguration', newConfig)}
                        config_key={advancedConfiguration.latchConfiguration}
                        setPageError={props.setError}
                        setPageLoading={props.setIsLoading}
                        latchConfigOpen={latchConfigOpen}
                        setLatchOpen={setLatchConfigOpen}
                        update_key={newConfig_key => props.onChange('latchConfiguration', newConfig_key)}
                    />

                    <GeoKeyConfigurationSection
                        config={advancedConfiguration.geokeyConfiguration}
                        reload={props.reload}
                        id={props.propertyId}
                        update={newConfig => props.onChange('geokeyConfiguration', newConfig)}
                        setIsLoading={props.setIsLoading}
                    />

                    <AmazonKeyConfigurationSection
                        config={advancedConfiguration.amazonKeyConfiguration}
                        update={newConfig => props.onChange('amazonKeyConfiguration', newConfig)}
                    />
                    <MasterLockConfigurationSection
                        propertyId={props.propertyId}
                        masterLockPropertyConfig={advancedConfiguration.masterLockPropertyConfiguration}
                        masterLockConfig={advancedConfiguration.masterLockConfiguration}
                        updateMasterConfig={(config: { 
                            locks?: MasterLockConfiguration; 
                            sharing?: MasterLockPropertyConfiguration; 
                        }) => {
                            const changes: { [key: string]: any } = {};      
                            changes.masterLockConfiguration = config.locks;
                            changes.masterLockPropertyConfiguration = config.sharing;
                            props.onMultipleChange(changes);
                        }}
                        updateSharing={(newConfig: MasterLockPropertyConfiguration) => {
                            props.onChange('masterLockPropertyConfiguration', newConfig)
                        }}
                        updateLocks={(newConfig: MasterLockConfiguration) => {
                            props.onChange('masterLockConfiguration', newConfig)
                        }}
                    />
                
                    <BrivoConfigurationSection
                        config={advancedConfiguration.brivoPropertyConfiguration}
                        reload={props.reload}
                        id={props.propertyId}
                        currentCompanyId={props.property && props.property.companyId? props.property.companyId: 0}
                        update={newConfig => props.onChange('brivoPropertyConfiguration', newConfig)}
                        setIsLoading={props.setIsLoading}
                        isFormSubmitted={isFormSubmitted}
                        setIsFormSubmitted={setIsFormSubmitted}
                        previousBrivoConfiguration={props.previousBrivoConfiguration}
                    />

                    <KeyCafeConfigurationSection
                        reload={props.reload}
                        propertyId={props.propertyId}
                        currentCompanyId={props.property && props.property.companyId? props.property.companyId: 0}
                        update={newConfig => {
                            if(newConfig && props.advancedConfiguration.keyCafePropertyConfiguration && (newConfig.keyCafeKeyGroupId !== props.advancedConfiguration.keyCafePropertyConfiguration.keyCafeKeyGroupId)){
                                console.log('changed keygroupid', newConfig)
                                setKeyCafeGroupIdChanged(true)
                                props.onChange('keyCafePropertyConfiguration', newConfig)
                            }else{
                                props.onChange('keyCafePropertyConfiguration', newConfig)
                            }
                        }}
                        updateKeys={newKeys => props.onChange('keyCafePropertyKeys',  newKeys)}
                        setIsLoading={props.setIsLoading}
                        isFormSubmitted={isFormSubmitted}
                        setIsFormSubmitted={setIsFormSubmitted}
                        advanceConfiguration={advancedConfiguration}
                        keyCafePropertyConfiguration={advancedConfiguration.keyCafePropertyConfiguration}
                        keyGroups={keyGroups}
                        keyLocations={keyLocations}
                        keyCafeKeys={keyCafeKeys}
                    />

                    <h4>Tour App</h4>
                    {!advancedConfiguration.onCellConfiguration ? (
                        <p>Web-Based tours are ENABLED as the Explore is DISABLED.</p>
                    ) : (
                        <p>Web-Based tours are DISABLED as the Explore is ENABLED.</p>
                    )}
                    <OnCellConfigurationSection
                        config={advancedConfiguration.onCellConfiguration}
                        update={newConfig => props.onChange('onCellConfiguration', newConfig)}
                    />
                    <h4>Advanced Configuration Options</h4>
                    <FormSelectLabeled
                        selectProps={{
                            id: 'report-frequency',
                            name: 'reportFrequency',
                            value: advancedConfiguration.reportFrequency,
                            disabled: isUser
                        }}
                        labelProps={{
                            labelText: 'Report Frequency'
                        }}
                        selectOptions={[
                            { value: ReportFrequency.None, label: 'None' },
                            { value: ReportFrequency.Monthly, label: 'Monthly' },
                            { value: ReportFrequency.Weekly, label: 'Weekly' }
                        ]}
                        onChange={props.onChange}
                    />
                    <FormInput
                        labelProps={{
                            labelText: 'Email Access Instructions',
                            invalidText:
                                'Please enter any special instructions necessary for clarification'
                        }}
                        inputProps={{
                            id: 'email-access-instructions',
                            name: 'emailAccessInstructions',
                            value: advancedConfiguration.emailAccessInstructions || '',
                            type: 'textarea',
                            maxLength: 2000,
                            disabled: isUser
                        }}
                        onChange={props.onChange}
                    />
                    <FormInput
                        labelProps={{
                            labelText: 'Text Access Instructions',
                            invalidText:
                                'Please enter brief special instructions for text recipients'
                        }}
                        inputProps={{
                            id: 'text-access-instructions',
                            name: 'textAccessInstructions',
                            value: advancedConfiguration.textAccessInstructions || '',
                            type: 'textarea',
                            maxLength: 200,
                            disabled: isUser
                        }}
                        onChange={props.onChange}
                    />

                    <FormInput
                        labelProps={{
                            labelText: 'Email Confirmation Instructions',
                            invalidText: 'Please enter any tour confirmation email instructions'
                        }}
                        inputProps={{
                            id: 'email-confirmation',
                            name: 'emailConfirmationInstructions',
                            value: advancedConfiguration.emailConfirmationInstructions || '',
                            type: 'textarea',
                            maxLength: 2000,
                            disabled: isUser
                        }}
                        onChange={props.onChange}
                    />
                    <FormInput
                        labelProps={{
                            labelText: 'Text Confirmation Instructions',
                            invalidText: 'Please enter any tour confirmation text instructions'
                        }}
                        inputProps={{
                            id: 'text-confirmation',
                            name: 'textConfirmationInstructions',
                            value: advancedConfiguration.textConfirmationInstructions || '',
                            type: 'textarea',
                            maxLength: 200,
                            disabled: isUser
                        }}
                        onChange={props.onChange}
                    />
                    <FormInput
                        labelProps={{
                            labelText: 'Unit # Instructions',
                            invalidText: 'Please enter any special instructions for reaching unit'
                        }}
                        inputProps={{
                            id: 'appless-unit-instrucitons',
                            name: 'unitInstructions',
                            value: advancedConfiguration.unitInstructions || '',
                            type: 'textarea',
                            maxLength: 1000,
                            disabled: isUser
                        }}
                        onChange={props.onChange}
                    />
                    <FormInput
                        labelProps={{
                            labelText: 'Custom Follow-Up Text',
                            invalidText:
                                "Please enter any follow-up instructions you'd like the prospect to receive."
                        }}
                        inputProps={{
                            id: 'custom-follow-up',
                            name: 'customFollowUp',
                            value: advancedConfiguration.customFollowUp || '',
                            type: 'textarea',
                            maxLength: 1000,
                            disabled: isUser
                        }}
                        onChange={props.onChange}
                    />
                    <h4>Property Administration</h4>
                    <PropertyCancellationDateSection
                        cancellationDate={advancedConfiguration.cancellationDate}
                        update={newDate => props.onChange('cancellationDate', newDate)}
                    />
                    <CompanyMigrationSection
                        companiesList={props.companiesList}
                        propertyId={props.propertyId}
                        setIsLoading={props.setIsLoading}
                        setError={props.setError}
                        currentCompanyId={props.property ? props.property.companyId : undefined}
                    />
                </>
            )}
            {hasFullAccess && (
                <>
                    <h4>Id Verification Configuration</h4>
                    <FormSelectLabeled
                        selectProps={{
                            id: 'id-verification-type',
                            name: 'idVerificationType',
                            value: advancedConfiguration.idVerificationType,
                            disabled: isUser
                        }}
                        labelProps={{
                            labelText: 'ID Verification Type'
                        }}
                        selectOptions={[
                            {
                                value: IdVerificationTypes.None,
                                label: 'None'
                            },
                            { value: IdVerificationTypes.CheckpointId, label: 'CheckpointId' },
                            { value: IdVerificationTypes.Onfido, label: 'Onfido' }
                        ]}
                        onChange={props.onChange}
                    />
                </>
            )}
            <FormValidationDisplay errorMessage={props.errorMessage} />

        </Form>
   );
};

export default AdvancedTab;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/AdvancedTab.tsx